<template>
  <multiselect
      id="dashboardQuickMapInfoFields"
      v-model="selectedOptions"
      @update:modelValue="onSelectOptions"
      :options="dashboardQuickMapInfoFields"
      :placeholder="$t('settings.generic.select-items')"
      label="translationKey" track-by="value"
      class="tracking-multiselect fit-content quick-map-info-fields"
      :multiple="true"
      :close-on-select="false"
      :clear-on-select="false"
      :preserve-search="true"
      :show-labels="false"
      :show-no-results="false"
      :show-no-options="false"
  >
    <template #option="props">
      <div class="tracking-multiselect-with-checkbox">
        <input type="checkbox" :checked="isOptionChecked(props.option.value)" @focus.prevent :key="props.option.value" />
        <span class="option__title">{{ $t(props.option.translationKey) }}</span>
      </div>
    </template>
    <template #selection="{ values, isOpen }">
      <span class="multiselect__single" v-if="values.length" v-show="!isOpen">
        {{ $t('settings.generic.selected-items') }} {{ values.length }}
      </span>
    </template>
    <template #placeholder>
      <span>
        {{ $t('settings.generic.select-placeholder') }}
      </span>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";
import {DashboardQuickMapInfoField} from "@/assets/js/enums/DashboardQuickMapInfoField.js";

export default {
  name: "ChooseDashboardQuickMapInfoField",
  components: {Multiselect},
  props: {
    modelValue: {
      type: Array,
      required: true,
      default() { return []; }
    }
  },
  data() {
    return {
      dashboardQuickMapInfoFields: DashboardQuickMapInfoField.all(),
      selectedOptions: (this.modelValue ?? [])
          .map(value => DashboardQuickMapInfoField.get(value))
          .filter(Boolean),
    }
  },
  watch: {
    modelValue(values = []) {
      const selectedOptions = values
          .map(value => DashboardQuickMapInfoField.get(value))
          .filter(Boolean);
      this.onSelectOptions(selectedOptions, false);
    },
  },
  methods: {
    isOptionChecked(value) {
      return this.selectedOptions?.some(x => x.value === value);
    },
    onSelectOptions(data, triggerValueUpdate = true) {
      this.selectedOptions = data;
      if (triggerValueUpdate) {
        this.$emit('update:modelValue', this.selectedOptions.map(x => x.value));
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';

.quick-map-info-fields {
  width: 240px;
}

@media (max-width: $breaking-point) {
  .quick-map-info-fields {
    width: 100%;
  }
}
</style>
